export default __webpack_public_path__ + "static/media/pdf.4102d6f8.svg";